import { DialogType } from './dialog-type.enum';

export class NotificationMessage {
  public dialogType?: DialogType;
  public title?: string;
  public messages?: string[];
  public eventId?: string;

  constructor(
    dialogType?: DialogType,
    title?: string,
    messages?: string[],
    eventId?: string
  ) {
    this.dialogType = dialogType;
    this.title = title;
    this.messages = messages;
    this.eventId = eventId;
  }
}
